import React, { useState, useRef, forwardRef, useImperativeHandle } from 'react';
import { setMapConfigMode } from 'actions/livefeed/steerpathMapActions'
import Toggle from 'components/common/Toggle'
//import { parseJwtToken } from 'components/pages/livefeed/utils'
import DelayInput from 'components/common/DelayInput'
import CustomTickBox from 'components/common/CustomTickBox'
import Select from 'react-select';
import './index.less'


const MapConfig = forwardRef((props, ref) => {
    const {
        dispatch, livefeedSlides, mapConfigMode, slideCurrentIndex,
        setLivefeedOptionsHandle, setLivefeedGlobalOptionsHandle
    } = props
    const { floorplanOptions: { duration: slideDuration, mapConfig, liveApiKey, mapApiKey } } = livefeedSlides[slideCurrentIndex];


    const [centerArr, setCenterArr] = useState([0, 0])
    const [globalMapConfig, setGlobalMapConfig] = useState(false);
    const mapApiInputRef = useRef(null)

    useImperativeHandle(ref, () => ({
        focusMapApiInput: () => {
            focusMapApiInput();
        }
    }));
    function focusMapApiInput() {
        mapApiInputRef.current.focus()
    }
    function handleInput(value, type) {
        globalMapConfig === true && setGlobalMapConfig(false)
        let floatValue = value ? value : 0
        let floatNum = value
        if (type === 'lng' || type === 'lat' || type === 'zoom' || type === 'bearing' || type === 'pitch') {
            floatNum = floatValue ? parseFloat(floatNum) : floatValue
        }
        switch (type) {
            case 'map':
                setLivefeedOptionsHandle('mapApiKey', value)
                break
            case 'live':
                setLivefeedOptionsHandle('liveApiKey', value)
                break
            case 'zoom':
                setLivefeedOptionsHandle('mapConfig', { zoom: floatNum })
                break
            case 'bearing':
                setLivefeedOptionsHandle('mapConfig', { bearing: floatNum })
                break
            case 'pitch':
                setLivefeedOptionsHandle('mapConfig', { pitch: floatNum })
                break
            case 'aniDuration':
                setLivefeedOptionsHandle('mapConfig', { aniDuration: value })
                break
            case 'use3dMap':
                setLivefeedOptionsHandle('mapConfig', { use3dMap: value })
                break
            case 'animationType':
                setLivefeedOptionsHandle('mapConfig', { animationType: value })
                break

        }
        if (type === 'lat' || type === 'lng') {
            let arr = []
            type === 'lng' ? arr = [floatNum, centerArr[1]] : arr = [centerArr[0], floatNum]
            setCenterArr(arr)
            setLivefeedOptionsHandle('mapConfig', { center: arr })
        }
        if (mapConfigMode === 'map_interact') {
            // don't need to rerender for aniDuration || animationType
            if (type === 'aniDuration' || type === 'animationType') {
                dispatch(setMapConfigMode("map_interact"))
            }
            else {
                dispatch(setMapConfigMode("user_input"))
            }
        }
    }
    const animationTypes = [
        { value: 'flyTo', label: 'Fly To', dataTip: `Configure animated transition options ` }, { value: 'panTo', label: 'Pan To' },
        { value: 'jumpTo', label: 'Jump To' }, { value: 'easeTo', label: 'Ease To' }
    ]

    return (
        <div className="gauge-grid-item">
            <div className="editor-container">
                <div className="header grid-item">Steerpath Map Config</div>

                {/*------------------------------- MAP API------------------------ */}

                <span className="editor-text grid-item grid-item__title"
                    data-tip={`Configure animated transition options `}
                    data-for="floorplanOptionsTooltip"
                    style={{ whiteSpace: "normal" }}>
                    API inputs
                </span>
                <div className="editor-text grid-item grid-item_flex">
                    <label className="api-label">Map Api Key</label>
                    <DelayInput
                        refProp={mapApiInputRef}
                        className="api-input"
                        value={mapApiKey}
                        onChange={(value) => handleInput(value, "map")}
                        required={true}
                    />
                </div>
                <div className="editor-text grid-item grid-item_flex">
                    <label className="api-label">Live Api Key</label>
                    <DelayInput
                        className="api-input"
                        value={liveApiKey}
                        onChange={(value) => handleInput(value, "live")}
                        required={true}
                    />
                </div>
                {/*------------------------------- MAP VIEW CONFIG------------------------ */}
                {mapApiKey &&
                    <React.Fragment>
                        <span className="editor-text grid-item grid-item__title grid-item_divider-line"
                            data-tip={`Configure animated transition options `}
                            data-for="floorplanOptionsTooltip"
                            style={{ whiteSpace: "normal" }}>
                            Map View Configuration
                            </span>
                        <div className="editor-text grid-item grid-item_flex">
                            <label className="api-label">Longitude</label>
                            <DelayInput
                                className="api-input"
                                value={mapConfig.center[0]}
                                onChange={(value) => handleInput(value, "lng")}
                                required={true}
                            />
                        </div>
                        <div className="editor-text grid-item grid-item_flex">
                            <label className="api-label">Latitude</label>
                            <DelayInput
                                className="api-input"
                                value={mapConfig.center[1]}
                                onChange={(value) => handleInput(value, "lat")}
                                required={true}
                            />
                        </div>
                        <div className="editor-text grid-item grid-item_flex">
                            <label className="api-label">Zoom</label>
                            <DelayInput
                                className="api-input"
                                value={mapConfig.zoom}
                                onChange={(value) => handleInput(value, "zoom")}
                                required={true}
                            />
                        </div>
                        <div className="editor-text grid-item grid-item_flex">
                            <label className="api-label">Bearing</label>
                            <DelayInput
                                className="api-input"
                                value={mapConfig.bearing}
                                onChange={(value) => handleInput(value, "bearing")}
                                required={true}
                            />
                        </div>
                        <div className="editor-text grid-item grid-item_flex">
                            <label className="api-label">Pitch</label>
                            <DelayInput
                                placeholder="0-60"
                                className="api-input"
                                value={mapConfig.pitch}
                                onChange={(value) => handleInput(value, "pitch")}
                                required={true}
                            />
                        </div>
                        {/* Use 3D Map */}
                        <div
                            data-tip={`Uncheck this checkbox if you encounter slow, lag in map transition animation`}
                            data-for="floorplanOptionsTooltip"
                            className="editor-text grid-item grid-item_flex">
                            <CustomTickBox
                                className="widget-label-setting"
                                onClick={() => {
                                    handleInput(!mapConfig.use3dMap, "use3dMap")
                                }}
                                label="Use 3D map"
                                isActive={mapConfig.use3dMap}
                            />
                        </div>
                        {/*------------------------------- MAP TRANSITION ANIMATION------------------------ */}
                        <span className="editor-text grid-item grid-item__title grid-item_divider-line"
                            data-tip={`Configure animated transition options `}
                            data-for="floorplanOptionsTooltip"
                            style={{ whiteSpace: "normal" }}>
                            Map Transition Animation
                            </span>
                        {/*Ani Duration max value is equal to half of slideDuration  */}
                        <div className="editor-text grid-item grid-item_flex">
                            <label
                                style={{
                                    textAlign: 'left',
                                    letterSpacing: '-0.3px',
                                    padding: 0, whiteSpace: 'normal'
                                }}
                                className="editor-text grid-item"
                                data-tip='Map transition animation type when changing between locations'
                                data-for="floorplanOptionsTooltip"
                            >
                                Animation type
                            </label>
                            <div className="editor-text grid-item reactSelect-dropdown-wrapper"
                                style={{
                                    width: "55%",
                                    paddingRight: 0,
                                    paddingLeft: 10
                                }}>
                                <Select
                                    className={"location-dropdown reactSelect-aniType-dropdown" }
                                    openOnFocus={true}
                                    clearable={false}
                                    closeOnSelect={true}
                                    onChange={(value) => handleInput(value, "animationType")}
                                    placeholder={mapConfig.animationType === null && "Click to see options"}
                                    value={mapConfig.animationType}
                                    options={animationTypes}
                                />
                            </div>
                        </div>
                        {/*Ani Duration max value is equal to half of slideDuration  */}
                        {mapConfig.animationType.value !== "jumpTo" &&
                            <div className="editor-text grid-item duration-button">
                                <label className="api-label">Animate Duration&nbsp;: {mapConfig.aniDuration}s
                            </label>
                                <input type="range" id="aniDuration"
                                    step={0.1}
                                    min={1} max={Math.floor(slideDuration / 2)}
                                    onChange={({ target: { value } }) => {
                                        handleInput(value, "aniDuration")
                                    }}
                                    value={mapConfig.aniDuration} />
                                <div className="indicator">{mapConfig.aniDuration} seconds</div>

                                <div className="marker pull-left">1</div>
                                <div className="marker pull-right">{Math.floor(slideDuration / 2)}</div>
                            </div>
                        }
                        {/*-------------------------------GLOBAL CONFIG APPLY ------------------------ */}
                        <div className="editor-text grid-item global-toggle-item grid-item_divider-line">
                            <div
                                data-tip="Apply this map config to all slides"
                                data-for="floorplanOptionsTooltip"
                                style={{ whiteSpace: "normal" }}
                                className="global-option-toggle"
                                onClick={() => {
                                    setGlobalMapConfig(!globalMapConfig);
                                    setLivefeedGlobalOptionsHandle(mapConfig)
                                }}>
                                <div className="toggle-text">Apply to all slides</div>
                                <Toggle isActive={globalMapConfig} />
                            </div>
                        </div>

                    </React.Fragment>
                }
            </div>
        </div>
    );
})

export default MapConfig;



// WEBPACK FOOTER //
// ./src/components/pages/livefeed/Editor/EditorContainer/FloorplanOptionContainer/MapConfig/index.jsx